import Vue from 'vue'
import logoLoading from '../../common/logoLoading.vue'

const Loading = Vue.extend(logoLoading);

export default {
  bind: function (el, binding) {
    const textExr = el.getAttribute('element-loading-text')
    const backgroundExr = el.getAttribute('element-loading-background');
    if (!el.style.position) {
      el.style.position = 'relative'
    }
    const loading = new Loading().$mount()
    el.instance = loading
    el.mask = loading.$el
    el.instance.text = textExr
    el.instance.background = backgroundExr
    el.appendChild(el.mask)
    if (binding.value) {
      Vue.nextTick(() => loading.visible = true)
    }
  },
  update: function (el, binding) {
    el.instance.text = el.getAttribute('element-loading-text')
    if (binding.value !== binding.oldValue) {
      Vue.nextTick(() => {
        el.instance.visible = binding.value
      })
    }
  },
  unbind: function (el, binding) {
    if (el.instance) {
      el.instance.visible = false
      el.removeChild(el.instance.$el)
      el.instance.$destroy()
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/logoLoading.js